import axios from 'axios';
import * as Sentry from '@sentry/react';

const sendTransaction = async (data) => {
  const config = {
    method: 'POST',
    url: `${process.env.REACT_APP_BASE_URL}/prxplasticos/transactions`,
    headers: {
      'content-type': 'application/json',
    },
    data,
  };

  try {
    const { data } = await axios(config);
    if (data?.transactionId) {
      return {
        success: true,
        data,
      };
    }
    return data;
  } catch (error) {
    Sentry.setContext('request', { config });
    Sentry.setContext('response', error.response.data);
    Sentry.captureMessage(config.url);
    return { success: false, data: error.response.data };
  }
};

export { sendTransaction };
